import React, { useState } from "react";
import { format, addDays } from "date-fns";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";

const PMFilters = ({
  decryptedText,
  partialPaymentInfo,
  paymentFilters,
  setPaymentFilters,
  searchFilterApplied,
  onClickSearch,
  onClickReset,
}) => {
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setPaymentFilters((prevs) => ({
      ...prevs,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    }));
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setPaymentFilters((prevs) => ({
      ...prevs,
      selectedStartDate: "",
      selectedEndDate: "",
    }));
  };

  return (
    <CommonFilterStructure
      from="partial-payments"
      decryptedText={decryptedText}
      setFilters={setPaymentFilters}
      filters={paymentFilters}
      searchFilterApplied={searchFilterApplied}
      onClickSearch={onClickSearch}
      openDateRanger={openDateRanger}
      onClickReset={onClickReset}
      handleDateRangeChange={handleDateRangeChange}
      setOpenDateRanger={setOpenDateRanger}
      rangeState={rangeState}
      clearDateRanger={clearDateRanger}
      partialPaymentInfo={partialPaymentInfo}
    />
  );
};

export default PMFilters;
